import React, { useRef } from 'react';
import cn from 'classnames';

import ActivationBox from '../ActivationBox';
import Button from '../../../components/common/ui/Button';
import { getDeviceDataFromMapping } from '../../../utils/devices';
import ErrorSmileIcon from '../../../assets/icons/activate/ErrorSmileIcon';
import { HELP_CENTER } from '../../../constants/externalLinks';

import styles from './styles.module.scss';

const ActivationError = ({ deviceInfo, errorTeamNotInformed }) => {
  const dataFromMapping = getDeviceDataFromMapping(
    deviceInfo?.device_info?.device_type_name,
  );
  const buttonRef = useRef();
  const deviceImagePath = dataFromMapping?.activationImagePath;

  const renderGeneralError = () => (
    <div className={styles.content}>
      <ErrorSmileIcon />
      <h3 className={cn('h3', styles.title)}>Oops, something went wrong.</h3>
      <p className={cn('text-s', styles.text)}>
        We're experiencing issues activating your device. Please reach out to
        customer support at&nbsp;
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={cn('text-s', styles.link)}
          href={HELP_CENTER}
        >
          Homefi Help Center
        </a>
        . Our business hours are 9 am - 9 pm 7 days a week.
      </p>
      <a
        href={HELP_CENTER}
        target="_blank"
        rel="noopener noreferrer"
        ref={buttonRef}
      >
        <Button className={styles.button}>Customer Support</Button>
      </a>
    </div>
  );

  const renderNiceError = () => (
    <div className={cn(styles.content, styles.contentNiceError)}>
      <p className={cn('text-m', styles.text, styles.sectionTitle)}>
        We’re Excited to Activate Your Service!
      </p>
      <p className={cn('text-s', styles.text)}>
        Thank you for providing your information! Our team is currently
        processing your activation.
      </p>
      <p className={cn('text-m', styles.text, styles.sectionTitle)}>
        During Business Hours (9:00 AM to 9:00 PM EST):
      </p>
      <p className={cn('text-s', styles.text)}>
        Your activation will be completed within 10-15 minutes.
      </p>
      <p className={cn('text-m', styles.text, styles.sectionTitle)}>
        Outside Business Hours:
      </p>
      <p className={cn('text-s', styles.text)}>
        Activations may take up to 24 hours.
      </p>
      <p className={cn('text-s', styles.text)}>
        You’ll receive an email confirmation once it’s successful.
      </p>
      <p className={cn('text-s', styles.text)}>
        If you don’t receive the confirmation email within the expected
        processing window, please don’t hesitate to reach out to us. You can
        visit our{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={cn('text-s', styles.link)}
          href={HELP_CENTER}
        >
          Help Center
        </a>{' '}
        to contact us.
      </p>
      <p className={cn('text-s', styles.text)}>
        We’re here to ensure you have a seamless experience. Thank you for
        choosing us!
      </p>
      <a
        href={HELP_CENTER}
        target="_blank"
        rel="noopener noreferrer"
        ref={buttonRef}
      >
        <Button className={styles.button}>Customer Support</Button>
      </a>
    </div>
  );

  return (
    <ActivationBox
      className={cn(styles.wrapper, { [styles.noDevice]: !deviceImagePath })}
    >
      <img
        src={deviceImagePath}
        alt=""
        className={cn({
          [styles.deviceImage]: true,
          [styles.deviceImageSmall]: !errorTeamNotInformed,
        })}
      />
      {errorTeamNotInformed ? renderGeneralError() : renderNiceError()}
    </ActivationBox>
  );
};

export default ActivationError;
